import { AssetReference } from './creativeset/element-asset';
import { WidgetEvent } from './widget-events';
export var InternalWidgetEvent;
(function (InternalWidgetEvent) {
    /** Event that occurs when the widget's view node has changed. */
    InternalWidgetEvent["ViewNodeChanged"] = "viewNodeChange";
})(InternalWidgetEvent || (InternalWidgetEvent = {}));
export const WIDGET_PROPERTY_PREFIX = 'custom:';
